import consultantBookingError from '../reducers/consultantBookingError';
import useActions from '../hooks/useActions';

export const logConsultantBookingError = e => dispatch =>
  dispatch({
    type: consultantBookingError.types.logConsultantBookingError,
    payload: e,
  });

export default () =>
  useActions({
    logConsultantBookingError,
  });
